import { render } from "./MentionIcon.vue?vue&type=template&id=563b686c"
import script from "./MentionIcon.vue?vue&type=script&lang=js"
export * from "./MentionIcon.vue?vue&type=script&lang=js"
script.render = render

export default script